import { type MantineThemeOverride, rem } from "@mantine/core";

export function customTheme(): MantineThemeOverride {
  return {
    headings: {
      sizes: {
        h1: { fontSize: rem(22) },
        h2: { fontSize: rem(19) },
        h3: { fontSize: rem(17) },
        h4: { fontSize: rem(16) },
        h5: { fontSize: rem(16) },
      },
    },
    colors: {
      line: [
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
        "#06C755",
      ],
    },
  };
}
